import { IconX } from '@rossum/ui/icons/tabler';
import {
  Box,
  Card,
  CardMedia,
  Chip,
  CircularProgress,
  IconButton,
  SvgIcon,
  Tooltip,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type AttachmentPreviewProps = {
  tooltipTitle: string;
  label: string;
  labelColor: string;
  thumbnailUrl?: string;
  onRemove?: () => void;
  isLoading?: boolean;
  dataCy?: string;
};

export const AttachmentPreview = ({
  tooltipTitle,
  label,
  labelColor,
  thumbnailUrl,
  onRemove,
  isLoading,
  dataCy,
}: AttachmentPreviewProps) => (
  <Tooltip title={tooltipTitle}>
    <Card
      elevation={2}
      sx={{
        position: 'relative',
        overflow: 'visible',
        width: 56,
        height: 68,
        borderRadius: borderRadius('s'),
      }}
    >
      {thumbnailUrl ? (
        <CardMedia
          component="img"
          image={thumbnailUrl}
          alt={tooltipTitle}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: borderRadius('s'),
          }}
        />
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            bgcolor: 'grey.300',
            borderRadius: borderRadius('s'),
          }}
        />
      )}
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(0, 0, 0, 0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: borderRadius('s'),
          }}
        >
          <CircularProgress size={20} sx={{ color: 'common.white' }} />
        </Box>
      )}
      <Chip
        label={label}
        size="small"
        sx={{
          position: 'absolute',
          bottom: 4,
          left: '50%',
          transform: 'translateX(-50%)',
          bgcolor: labelColor,
          color: 'common.white',
          fontSize: 10,
          fontWeight: 700,
          height: 18,
          '& .MuiChip-label': { px: 0.75 },
        }}
      />
      {!isLoading && onRemove && (
        <IconButton
          data-cy={dataCy}
          size="small"
          onClick={onRemove}
          sx={{
            position: 'absolute',
            top: -12,
            right: -12,
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',

            '&:hover': {
              bgcolor: t => t.palette.background.default,
            },
          }}
        >
          <SvgIcon fontSize="small">
            <IconX />
          </SvgIcon>
        </IconButton>
      )}
    </Card>
  </Tooltip>
);
